import { Axios } from 'axios';
import { CONTROLLER_API_PREFIX, UNI_API_CONTROLLER } from 'app/constants';

/**
 * A service class acts as a proxy, encapsulating the details of the underlying HTTP client
 * and exposing a consistent API for the application's data needs
 *
 * This class has a 1:1 relationship with the `LicenseController` from the NestAPI layer,
 */
class LicenseService {
  #httpClient: Axios;
  baseUrl: string;

  constructor(httpClient: Axios) {
    this.#httpClient = httpClient;
    this.baseUrl = `/${CONTROLLER_API_PREFIX}/${UNI_API_CONTROLLER.license}`;
  }

  async isLicenseRequiredForReferenceUse(assetId: string): Promise<boolean> {
    const response = await this.#httpClient.get(
      `${this.baseUrl}/required-for-reference-use/${assetId}`
    );
    return response.data;
  }
}

export default LicenseService;
